/**
 * BatchScheduleTab — Wrapper that renders ScheduleManager within a batch context.
 *
 * Reads the batch's project_id from the route param and passes it down.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { getBatch } from '../../services/batchApi';
import ScheduleManager from './ScheduleManager';

const BatchScheduleTab: React.FC = () => {
  const { batchId } = useParams<{ batchId: string }>();

  const { data: batch, isLoading } = useQuery(
    ['batch', batchId],
    () => getBatch(batchId!),
    { enabled: !!batchId, staleTime: 30_000 },
  );

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!batch?.project_id) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          This batch is not associated with a project. Scheduling requires a project context.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <ScheduleManager projectId={batch.project_id} batchId={batchId} />
    </Box>
  );
};

export default BatchScheduleTab;
